export default "__VITE_ASSET__DNVpNHED__"